'use strict';
var $ = require('../internals/export');
var parseInt = require('../internals/number-parse-int');

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/es.number.parse-int.js
// module id = 1035
// module chunks = 0